import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { useMediaQuery } from 'react-responsive'

import Container from '@components/Container'
import Box from '@components/Box'
import { SButtonHeader } from '@components/Button/Button'

import Logo from '@icons/logo.inline.svg'
import User from '@icons/user.inline.svg'
import { md, xl } from '@styles/variables/breakpoints'
import { above } from '@styles/mixins/breakpoints'
import Ecosystem from './Ecosystem/'
import Contact from './Contact'

const SHeader = styled.header`
  height: 102px;
  ${above('md')(css`
    height: 63px;
  `)}
`
const SLine = styled.div`
  background: ${({ theme }) => theme.gradients.main};
  height: 3px;

  ${above('md')(css`
    height: 6px;
  `)}
`
const SEcosystem = styled(Ecosystem)`
  margin-right: 16px;
`

const SLogo = styled(Logo)`
  margin-right: 20px;
`

const SLogoLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`

const SContainer = styled(Container)`
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  ${above('md')(css`
    height: calc(100% - 6px);
    padding-top: 0;
  `)}
`

const SMobileButton = styled(SButtonHeader)`
  justify-content: center;
  margin: 12px 24px 20px 24px;
`

const SLkButton = styled(User)`
  width: 20px;
  height: 20px;
`

export interface IHeaderProps {
  contacts?: ReactNode
  contractHref: string
  lkHref?: string
}

const Header: React.FC<IHeaderProps> = ({ contacts, contractHref, lkHref }) => {
  const isLg = useMediaQuery({ minWidth: xl })
  const isSm = useMediaQuery({ maxWidth: md - 1 })

  const lkLink = lkHref ?? 'https://lk.npfsb.ru/111'

  return (
    <SHeader>
      <SLine />
      <SContainer display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" justifyContent="center">
          {!isSm && <SEcosystem />}
          <SLogoLink href="/">
            <SLogo />
          </SLogoLink>
          {isLg && contacts && <Contact desc="горячая линия">{contacts}</Contact>}
        </Box>
        <Box display="flex" alignItems="center">
          {isSm ? (
            <a href={lkLink} target="_blank" rel="noreferrer">
              <SLkButton />
            </a>
          ) : (
            <SButtonHeader link={true} href={lkLink} target="_blank" icon={<User />} type="secondary" mr="8px">
              Личный кабинет
            </SButtonHeader>
          )}

          {!isSm && (
            <SButtonHeader as="a" href={contractHref} target="_blank" type="primary">
              Заключить договор
            </SButtonHeader>
          )}
        </Box>
      </SContainer>
      {isSm && (
        <SMobileButton as="a" href={contractHref} target="_blank" type="primary">
          Заключить договор
        </SMobileButton>
      )}
    </SHeader>
  )
}

export default Header
